/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoleSearchSortingQuery } from './RoleSearchSortingQuery';
import {
    RoleSearchSortingQueryFromJSON,
    RoleSearchSortingQueryFromJSONTyped,
    RoleSearchSortingQueryToJSON,
    RoleSearchSortingQueryToJSONTyped,
} from './RoleSearchSortingQuery';
import type { ResourceFilter } from './ResourceFilter';
import {
    ResourceFilterFromJSON,
    ResourceFilterFromJSONTyped,
    ResourceFilterToJSON,
    ResourceFilterToJSONTyped,
} from './ResourceFilter';
import type { RoleSearchOrderByPaginationQuery } from './RoleSearchOrderByPaginationQuery';
import {
    RoleSearchOrderByPaginationQueryFromJSON,
    RoleSearchOrderByPaginationQueryFromJSONTyped,
    RoleSearchOrderByPaginationQueryToJSON,
    RoleSearchOrderByPaginationQueryToJSONTyped,
} from './RoleSearchOrderByPaginationQuery';
import type { UserType } from './UserType';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    UserTypeToJSONTyped,
} from './UserType';
import type { ApplicationFilterRequest } from './ApplicationFilterRequest';
import {
    ApplicationFilterRequestFromJSON,
    ApplicationFilterRequestFromJSONTyped,
    ApplicationFilterRequestToJSON,
    ApplicationFilterRequestToJSONTyped,
} from './ApplicationFilterRequest';

/**
 * 
 * @export
 * @interface RoleSearchRequest
 */
export interface RoleSearchRequest {
    /**
     * 
     * @type {ApplicationFilterRequest}
     * @memberof RoleSearchRequest
     */
    applicationFilter?: ApplicationFilterRequest;
    /**
     * 
     * @type {RoleSearchOrderByPaginationQuery}
     * @memberof RoleSearchRequest
     */
    paginationQuery?: RoleSearchOrderByPaginationQuery;
    /**
     * 
     * @type {Array<any>}
     * @memberof RoleSearchRequest
     */
    permissionIds?: Array<any> | null;
    /**
     * 
     * @type {Array<any>}
     * @memberof RoleSearchRequest
     */
    roleIds?: Array<any> | null;
    /**
     * 
     * @type {RoleSearchSortingQuery}
     * @memberof RoleSearchRequest
     */
    sortingQuery?: RoleSearchSortingQuery;
    /**
     * 
     * @type {string}
     * @memberof RoleSearchRequest
     */
    textFilter?: string | null;
    /**
     * 
     * @type {UserType}
     * @memberof RoleSearchRequest
     */
    userType?: UserType;
    /**
     * 
     * @type {ResourceFilter}
     * @memberof RoleSearchRequest
     */
    resourceFilter?: ResourceFilter;
}



/**
 * Check if a given object implements the RoleSearchRequest interface.
 */
export function instanceOfRoleSearchRequest(value: object): value is RoleSearchRequest {
    return true;
}

export function RoleSearchRequestFromJSON(json: any): RoleSearchRequest {
    return RoleSearchRequestFromJSONTyped(json, false);
}

export function RoleSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleSearchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationFilter': json['applicationFilter'] == null ? undefined : ApplicationFilterRequestFromJSON(json['applicationFilter']),
        'paginationQuery': json['paginationQuery'] == null ? undefined : RoleSearchOrderByPaginationQueryFromJSON(json['paginationQuery']),
        'permissionIds': json['permissionIds'] === undefined ? undefined : json['permissionIds'] === null ? null : json['permissionIds'],
        'roleIds': json['roleIds'] === undefined ? undefined : json['roleIds'] === null ? null : json['roleIds'],
        'sortingQuery': json['sortingQuery'] == null ? undefined : RoleSearchSortingQueryFromJSON(json['sortingQuery']),
        'textFilter': json['textFilter'] === undefined ? undefined : json['textFilter'] === null ? null : json['textFilter'],
        'userType': json['userType'] == null ? undefined : UserTypeFromJSON(json['userType']),
        'resourceFilter': json['resourceFilter'] == null ? undefined : ResourceFilterFromJSON(json['resourceFilter']),
    };
}

export function RoleSearchRequestToJSON(json: any): RoleSearchRequest {
    return RoleSearchRequestToJSONTyped(json, false);
}

export function RoleSearchRequestToJSONTyped(value?: RoleSearchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationFilter': ApplicationFilterRequestToJSON(value['applicationFilter']),
        'paginationQuery': RoleSearchOrderByPaginationQueryToJSON(value['paginationQuery']),
        'permissionIds': value['permissionIds'],
        'roleIds': value['roleIds'],
        'sortingQuery': RoleSearchSortingQueryToJSON(value['sortingQuery']),
        'textFilter': value['textFilter'],
        'userType': UserTypeToJSON(value['userType']),
        'resourceFilter': ResourceFilterToJSON(value['resourceFilter']),
    };
}

